import { NewsThumbnailSkeleton } from '@terminal/components/news-thumbnail-skeleton/NewsThumbnailSkeleton';

export const NewsLoadingState = () => (
  <>
    <NewsThumbnailSkeleton />
    <NewsThumbnailSkeleton />
    <NewsThumbnailSkeleton />
  </>
);
